import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useSingleSaleHeaderStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            [theme.breakpoints.up('md')]: {
                borderBottom: '1px solid #d4d4d4'
            }
        },
        container: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%'
        },
        containerSearch: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        },
        boxSearch: {
            paddingTop: 32,
            paddingBottom: 24,

            [theme.breakpoints.up('md')]: {
                paddingTop: 40,
                paddingBottom: 20
            }
        },
        errorBorder: {
            '& fieldset': {
                'borderColor': '#EF4F57 !important',
                '&:hover': {
                    borderColor: '#EF4F57 !important'
                }
            }
        }
    })
);
